/* Home Design 4 (revised) — reveals, counters, matrix tabs, search compose. */
(function () {
  function boot() {
    /* Matrix tabs */
    document.querySelectorAll('[data-bhs-tabs]').forEach(function (root) {
      var tabs = root.querySelectorAll('[data-tab]');
      var panels = root.querySelectorAll('[data-panel]');
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var name = tab.getAttribute('data-tab');
          tabs.forEach(function (t) { t.classList.toggle('is-active', t === tab); });
          panels.forEach(function (p) { var on = p.getAttribute('data-panel') === name; p.hidden = !on; p.classList.toggle('is-active', on); });
        });
      });
    });

    /* Directory: CLICK a row -> show matching preview panel. On mobile the panel opens directly below the clicked row. */
    document.querySelectorAll('[data-bhs-dir]').forEach(function (dir) {
      var rows = dir.querySelectorAll('.row');
      var panels = dir.querySelectorAll('.prev-panel');
      var prev = dir.querySelector('.dir-prev');
      var mq = window.matchMedia('(max-width: 760px)');
      function panelFor(i) { var el = null; panels.forEach(function (p) { if (p.getAttribute('data-panel-i') === String(i)) el = p; }); return el; }
      function place() {
        rows.forEach(function (row) {
          var p = panelFor(row.getAttribute('data-i'));
          if (!p) return;
          if (mq.matches) { row.insertAdjacentElement('afterend', p); }
          else if (prev && p.parentNode !== prev) { prev.appendChild(p); }
        });
      }
      function show(i) {
        rows.forEach(function (r) { r.classList.toggle('on', r.getAttribute('data-i') === String(i)); });
        panels.forEach(function (p) { var on = p.getAttribute('data-panel-i') === String(i); p.hidden = !on; p.classList.toggle('is-active', on); });
      }
      rows.forEach(function (row) {
        var i = row.getAttribute('data-i');
        row.addEventListener('click', function () { place(); show(i); });
        row.addEventListener('keydown', function (e) {
          var list = Array.prototype.slice.call(rows);
          var idx = list.indexOf(row);
          if (e.key === 'ArrowDown') { e.preventDefault(); (list[idx + 1] || list[0]).focus(); }
          if (e.key === 'ArrowUp') { e.preventDefault(); (list[idx - 1] || list[list.length - 1]).focus(); }
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); place(); show(i); }
        });
      });
      place();
      mq.addEventListener('change', function () { place(); });
    });

    /* Search: fold the filter selects into the query on submit */
    document.querySelectorAll('[data-bhs-cmd]').forEach(function (form) {
      var input = form.querySelector('input[name="q"]');
      form.addEventListener('submit', function () {
        if (!input) return;
        var parts = [];
        form.querySelectorAll('[data-f]').forEach(function (el) {
          var v = (el.value || '').trim();
          if (v) { v = v.replace(/\s*\([^)]*\)\s*/g, '').trim(); parts.push(v); } /* drop "(SG)" etc */
        });
        if (parts.length) input.value = (input.value ? input.value + ' ' : '') + parts.join(' ');
      });
    });

    /* Counters */
    function animateCount(el) {
      if (el.dataset.done) return; el.dataset.done = '1';
      var target = parseFloat(el.getAttribute('data-count')) || 0;
      var prefix = el.getAttribute('data-prefix') || '', suffix = el.getAttribute('data-suffix') || '';
      var dur = 1300, t0 = null;
      function fmt(n) { return prefix + Math.round(n).toLocaleString('en-GB') + suffix; }
      function frame(t) { if (!t0) t0 = t; var p = Math.min((t - t0) / dur, 1); el.textContent = fmt(target * (1 - Math.pow(1 - p, 3))); if (p < 1) requestAnimationFrame(frame); }
      requestAnimationFrame(frame);
    }

    /* Reveals + counters */
    var reveals = document.querySelectorAll('[data-reveal]');
    var counters = document.querySelectorAll('[data-count]');
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); e.target.querySelectorAll('[data-count]').forEach(animateCount); io.unobserve(e.target); } });
      }, { threshold: 0.12 });
      reveals.forEach(function (el) { io.observe(el); });
      var cio = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { animateCount(e.target); cio.unobserve(e.target); } }); }, { threshold: 0.5 });
      counters.forEach(function (el) { if (!el.closest('[data-reveal]')) cio.observe(el); });
    } else {
      reveals.forEach(function (el) { el.classList.add('is-in'); });
      counters.forEach(animateCount);
    }
  }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
})();


/* ===== Custom combobox (typeable + dropdown) ===== */
(function () {
  function initCombo(box) {
    var input = box.querySelector('.fcombo__input');
    var list = box.querySelector('.fcombo__list');
    if (!input || !list) return;
    var opts = [].slice.call(list.querySelectorAll('.fcombo__opt'));
    var none = list.querySelector('.fcombo__none');
    var active = -1;

    function place() {
      var r = input.getBoundingClientRect();
      list.style.left = r.left + 'px';
      list.style.width = r.width + 'px';
      var below = window.innerHeight - r.bottom - 12;
      var above = r.top - 12;
      if (below < 180 && above > below) {
        list.style.top = 'auto';
        list.style.bottom = (window.innerHeight - r.top) + 'px';
        list.style.maxHeight = Math.min(320, above) + 'px';
      } else {
        list.style.bottom = 'auto';
        list.style.top = r.bottom + 'px';
        list.style.maxHeight = Math.max(160, Math.min(320, below)) + 'px';
      }
    }
    function open() { list.hidden = false; box.classList.add('is-open'); input.setAttribute('aria-expanded', 'true'); place(); }
    function close() { list.hidden = true; box.classList.remove('is-open'); input.setAttribute('aria-expanded', 'false'); active = -1; paint([]); }
    function visible() { return opts.filter(function (o) { return !o.hidden; }); }
    function paint(vis) {
      opts.forEach(function (o) { o.classList.remove('is-active'); o.setAttribute('aria-selected', 'false'); });
      if (vis[active]) { vis[active].classList.add('is-active'); vis[active].setAttribute('aria-selected', 'true'); vis[active].scrollIntoView({ block: 'nearest' }); }
    }
    function filter() {
      var q = input.value.trim().toLowerCase();
      var any = false;
      opts.forEach(function (o) {
        var show = !q || o.textContent.toLowerCase().indexOf(q) > -1;
        o.hidden = !show; if (show) any = true;
      });
      if (none) none.hidden = any;
      active = -1;
    }
    function choose(o) { input.value = o.getAttribute('data-val'); close(); input.dispatchEvent(new Event('change', { bubbles: true })); }

    input.addEventListener('focus', function () { filter(); open(); });
    input.addEventListener('click', function () { filter(); open(); });
    input.addEventListener('input', function () { open(); filter(); paint(visible()); });
    input.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown') { e.preventDefault(); if (list.hidden) { filter(); open(); } var v = visible(); active = Math.min(active + 1, v.length - 1); paint(v); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); var v2 = visible(); active = Math.max(active - 1, 0); paint(v2); }
      else if (e.key === 'Enter') { var v3 = visible(); if (!list.hidden && active > -1 && v3[active]) { e.preventDefault(); choose(v3[active]); } }
      else if (e.key === 'Escape') { close(); }
    });
    opts.forEach(function (o) { o.addEventListener('mousedown', function (e) { e.preventDefault(); choose(o); }); });
    input.addEventListener('blur', function () { setTimeout(close, 140); });
    document.addEventListener('click', function (e) { if (!box.contains(e.target)) close(); });
    window.addEventListener('scroll', function () { if (!list.hidden) place(); }, true);
    window.addEventListener('resize', function () { if (!list.hidden) place(); });
  }
  document.querySelectorAll('[data-combo]').forEach(initCombo);
})();
